import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { useResolvedOnServer } from '~/context/common/DeferredResolutionContext';
import VehicleContext, {
  useGetIsWIPVehicle,
  useGetVehicleDetails
} from '~/context/vdp/VehicleContext';
import useSkipFirstFetchIfResolvedOnServer from '~/hooks/common/useSkipFirstFetchIfResolvedOnServer';
import fetchWhyBuyData from '~/services/vdp/fetchWhyBuyData';
import { generateErrorLogger } from '~/utilities/loggers';
import useShowVaultWhyBuyContent from '../useHasVaultWhyBuyData';

export default function useGetWhyBuyData() {
  const vaultWhyBuyContentExists = useShowVaultWhyBuyContent();
  const isWIPVehicle = useGetIsWIPVehicle();
  const { kbbVehicleId = 0 } = useGetVehicleDetails();
  const {
    fetchWhyBuyFlag,
    ymmtWhyBuy: { setData, setError, setLoaded, setLoading }
  } = useContext(VehicleContext);
  const { whyBuy: whyBuyResolvedOnServer } = useResolvedOnServer();

  const shouldSkipFetch = useSkipFirstFetchIfResolvedOnServer(
    whyBuyResolvedOnServer
  );

  useEffectWithController(
    controller => {
      if (!kbbVehicleId || vaultWhyBuyContentExists || isWIPVehicle) {
        setLoaded();

        return;
      }

      if (shouldSkipFetch()) return;

      setLoading();

      fetchWhyBuyData(kbbVehicleId, controller)
        .then(setData)
        .catch(
          generateErrorLogger(
            'Get Ymmt Why Buy',
            {},
            { callback: setError, controller }
          )
        );
    },
    [
      fetchWhyBuyFlag,
      isWIPVehicle,
      kbbVehicleId,
      setData,
      setError,
      setLoaded,
      setLoading,
      shouldSkipFetch,
      vaultWhyBuyContentExists
    ]
  );
}
